import type { AuthMethod } from "@defuse-protocol/internal-utils"
import { ChainType } from "@src/hooks/useConnectWallet"

export const CHAIN_TYPE_TO_AUTH_METHOD = {
  [ChainType.EVM]: "evm",
  [ChainType.Near]: "near",
  [ChainType.Solana]: "solana",
  [ChainType.WebAuthn]: "webauthn",
  [ChainType.Ton]: "ton",
  [ChainType.Stellar]: "stellar",
  [ChainType.Tron]: "tron",
} satisfies Record<ChainType, AuthMethod>

export function chainTypeToAuthMethod(chainType: ChainType): AuthMethod {
  return CHAIN_TYPE_TO_AUTH_METHOD[chainType]
}
